import http from "../../core/services/http.service";
import ExportsService from "@/core/services/exports.service";
import {AppSettings} from "@/shared/AppSettings";

const ReportsService = {
  getReports(params = null, expand = '') {
    return http.get(`/api/v1/reports/?expand=${expand}`, {params});
  },
  async generateAndDownloadReport(uuid, params = {}) {

    let response = await ExportsService.generateToken();
    if (!response.success) {
      return false;
    }
    params = {
      ...params,
      token: response.body.token
    }
    window.open(
      ExportsService.prepareExportUrl(`/api/v1/reports/${uuid}/generate-report/`, params),
      '_blank'
    );
  },
  async generateReport(uuid, params = {}) {

    let response = await ExportsService.generateToken();
    if (!response.success) {
      return false;
    }
    params = {
      ...params,
      token: response.body.token
    }
    http.get(ExportsService.prepareExportUrl(`/api/v1/reports/${uuid}/generate-report/`, params));
  },
  getConfigurationData(uuid) {
    return http.get(`/api/v1/reports/${uuid}/configure-report/`, {});
  },
  saveConfigurationData(uuid, params) {
    return http.post(`/api/v1/reports/${uuid}/configure-report/`, params);
  },
  validateReport(uuid, params) {
    return http.post(`/api/v1/reports/${uuid}/validate-report/`, params);
  },
  getExistingTags() {
    return http.get(`/api/v1/reports/existing-tags/`, {});
  }
};

export default ReportsService;
